import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import Input from "../components/Input";
import Card from "../components/Card";
import { MailIcon } from "../components/Icons";
import { authAPI } from "../services/api";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await authAPI.forgotPassword(email);

      if (response.success) {
        setSubmitted(true);

        // Navigate to OTP verification after 2 seconds
        setTimeout(() => {
          navigate("/otp-verification", {
            state: {
              email: email,
              type: "reset",
            },
          });
        }, 2000);
      }
    } catch (err) {
      setError(err.error || "Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-main)] flex items-center justify-center px-4 sm:px-6 md:px-8">
      <Card className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 card-gradient rounded-full flex items-center justify-center">
            <MailIcon className="w-10 h-10 text-primary" />
          </div>
          <h1 className="text-3xl font-bold text-[var(--text-primary)] mb-2">
            Forgot Password?
          </h1>
          <p className="text-[var(--text-primary)]">
            {submitted
              ? "Check your email for reset instructions"
              : "Enter your email to receive reset instructions"}
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-500/10 border border-red-500/50 rounded-lg">
            <p className="text-red-500 text-sm">{error}</p>
          </div>
        )}

        {!submitted ? (
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              type="email"
              label="Email Address"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              icon={<MailIcon className="w-5 h-5" />}
              required
            />

            <Button type="submit" fullWidth disabled={loading}>
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>

            <Button
              type="button"
              variant="secondary"
              fullWidth
              onClick={() => navigate("/login")}
            >
              Back to Login
            </Button>
          </form>
        ) : (
          <div className="text-center space-y-6">
            <div className="py-8">
              <div className="w-16 h-16 mx-auto mb-4 bg-primary-gradient rounded-full flex items-center justify-center">
                <svg
                  className="w-8 h-8 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              </div>
              <p className="text-[var(--text-primary)] mb-2">Email sent successfully!</p>
              <p className="text-[var(--text-primary)] text-sm">
                Redirecting to verification...
              </p>
            </div>
          </div>
        )}

        <div className="mt-6 text-center text-sm text-[var(--text-primary)]">
          Remember your password?{" "}
          <button
            onClick={() => navigate("/login")}
            className="text-[var(--text-primary)] hover:underline font-semibold"
          >
            Sign In
          </button>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
